import { useEffect } from 'react';

import { RangePicker } from 'components/date';
import { convertDataRangeToCriterionValue } from 'components/search';
import { useIsWoopDemoMode } from 'features/workload-optimization';
import { DateRangeFilter } from '@cast/shared-date-ui';

import {
  formatRightsizingTimeRangeInputValue,
  RIGHTSIZING_QUERY_PARAM_KEYS,
} from '../../../_hooks/useRightsizingTimeRangeSelection';
import { rangeCriterion } from '../_constants';
import { useWorkloadEventsTimeRangeSelection } from '../_hooks/useWorkloadEventsTimeRangeSelection';

import { useSearchCriterion } from '@cast/shared-search-ui';

const filterPresets = [
  DateRangeFilter.Last15Mins,
  DateRangeFilter.Last30Mins,
  DateRangeFilter.LastHour,
  DateRangeFilter.Last24Hours,
  DateRangeFilter.Last7Days,
  DateRangeFilter.Last30Days,
];

export const EventsRangePicker = () => {
  const isWoopDemoMode = useIsWoopDemoMode();
  const dateRangeCriterion = useSearchCriterion(rangeCriterion);
  const { initialState, from, to, timeZone, preset } =
    useWorkloadEventsTimeRangeSelection();

  useEffect(
    () => {
      if (from || to || preset) {
        dateRangeCriterion.setValue(
          convertDataRangeToCriterionValue({ from, to }, timeZone, preset)
        );
      }
    },
    // run only on mount to update range for events if it was changed at charts tab
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <RangePicker
      queryParamKeys={RIGHTSIZING_QUERY_PARAM_KEYS}
      initialPreset={initialState.preset}
      initialTimezone={initialState.timeZone}
      filterPresets={filterPresets}
      allowTimeInput
      triggerInputProps={{
        size: 'small',
        sx: { width: 290 },
      }}
      inputValue={formatRightsizingTimeRangeInputValue}
      hideTimezonePicker={isWoopDemoMode}
      onChange={(date, timezone, preset) => {
        // We need to set a search value for the dateRange to reuse events API as it's coupled to search right now.
        // The regular RangePicker is used to sync the selected range between the tabs.
        dateRangeCriterion.setValue(
          convertDataRangeToCriterionValue(date, timezone, preset)
        );
      }}
    />
  );
};
